import { observer } from "mobx-react";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { PositionedSpinner } from "../../../../../components/ui/PositionedSpinner";
import { useCurrentOrganisationId } from "../../../../../services/local/organisationContext/OrganisationContextModel";
import { BusinessAreasSidebarModel } from "./BusinessAreasSidebar_model";
import { SingleForm } from "../../../../../pages/change/forms/singleFormModel/SingleForm_view";

export interface BusinessAreasSidebarProps {
  updateBusinessAreas: (businessAreas: number[]) => void;
  currentIds: number[];
}

export const BusinessAreasSidebar: React.FC<BusinessAreasSidebarProps> = observer(
  ({ updateBusinessAreas, currentIds }) => {
    const organisationId = useCurrentOrganisationId();
    const { projectId } = useParams();
    const [model] = useState(
      () => new BusinessAreasSidebarModel(organisationId, +projectId, currentIds, updateBusinessAreas)
    );
    if (model.isLoading) return <PositionedSpinner />;

    return (
      <div className="container-fluid">
        <SingleForm model={model.formModel} />
      </div>
    );
  }
);
